module.exports = __webpack_public_path__ + "static/HBR_Light-Dark-4ab139fb472ac89d6281c04a2bcb05d3.mp4";